import React from 'react';
import one from '../Assets/dungeon.png'
import two from '../Assets/Vector-2.png'
import three from '../Assets/Vector-1.png'
import ball1 from '../Assets/Ellipse 19.png'
import ball2 from '../Assets/Ellipse 9.png'

export default function Comapnies() {
    return (
        <>
            <div className="Companies">
                <div className="one">
                    <img src={one} alt="" />
                    <h1>UAE Free Zone Company</h1>
                    <p>Your registration agent, will answer all <br />
                        of your questions and help you to reach <br />
                        a conclusion that meets your objectives <br />
                        of investing in the UAE.</p>
                    <span>Get Started</span>
                </div>

                <div className="one">
                    <img src={two} alt="" />
                    <h1>Dubai Local Companies</h1>
                    <p>The Dubai LLC formation documn=ents <br />
                        are actually articles of organisation or a <br />
                        certificate of organization. You can get <br />
                        yours today.</p>
                    <span>Get Started</span>
                </div>

                <div className="one">
                    <img src={three} alt="" />
                    <h1>Offshore Companies</h1>
                    <p>You can register an offshore company <br />
                        and open its bank account in Dubai. <br />
                        Your agent will help you along all the <br />
                        process.</p>
                    <span>Get Started</span>
                </div>
            </div>
            <div className="companyBall">
                <div className="comanyLeft">
                    <img src={ball1} alt="" />

                </div>
                <div className="comanyRight">
                    <img src={ball2} alt="" />

                </div>
            </div>
        </>
    );
}
